<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermission" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermission" [position]="'inline'" [lang]="currentLang">
        <span class="icon">
            <i class="fi fi-ss-search-alt"></i>
            {{"AllocationConstraint.Inbound.Header" | translate}}
        </span>
    </h1>
    <p-card>
      <p-accordion>
          <p-accordionTab
                  header="{{ 'Common.Form.Header' | translate }}"
                  [selected]="isSearchFormOpen">
              <form [formGroup]="searchForm">
                  <div class="p-fluid formgrid grid">
                      <div class="field col-3"><!-- 單選 貨主-->
                          <label>{{ 'AllocationConstraint.Search.storer' | translate }}</label>
                          <p-dropdown  formControlName="storer" [options]="storerOption"
                                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                      [showClear]="true"
                                      [virtualScroll]="false"
                          >
                          </p-dropdown>
                          <div *ngIf="((submitted || searchForm.controls.storer.touched) && searchForm?.controls?.storer?.errors?.required )" >
                              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                          </div>
                      </div>

                      <div class="field col-3"><!-- 單選 品牌-->
                        <label>{{ 'AllocationConstraint.Search.brand' | translate }}</label>
                        <p-dropdown  formControlName="brand" [options]="brandOptions"
                                    [showClear]="true"
                                    [filter]="true"
                                    filterBy="label"
                                    [virtualScroll]="false"
                                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                        </p-dropdown>
                      </div>

                      <div class="field col-3"><!-- 多筆輸入 料號 -->
                          <label>{{ 'AllocationConstraint.Search.sku' | translate }}</label>
                          <input type="text" pInputText formControlName="sku"/>
                      </div>

                      <div class="field col-3"><!-- 多選 比對類型-->
                        <label>{{ 'AllocationConstraint.Search.checkType' | translate }}</label>
                        <p-multiSelect  formControlName="checkTypes"
                                      [options]="checkTypeOption"
                                      optionLabel="label"
                                      optionValue="value"
                                      [virtualScrollItemSize]="30"
                                      [virtualScroll]="true"
                                      scrollHeight="200px"
                                      display="chip"
                                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                        </p-multiSelect>
                    </div>

                      <div class="field col-3"><!-- y/n 生效狀態-->
                          <label>{{ 'AllocationConstraint.Search.activeFlag' | translate }}</label>
                          <p-dropdown  formControlName="activeFlag"
                                      [options]="commonOption"
                                      optionLabel="label"
                                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                          </p-dropdown>
                      </div>
                  </div>

                  <div>
                      <button
                              pButton
                              pRipple
                              label="{{ 'Common.Button.Search' | translate }}"
                              (click)="searchBtnClick($event)">
                      </button>
                      <button
                              pButton
                              pRipple
                              label="{{ 'Common.Button.Reset' | translate }}"
                              type="reset"
                              class="p-button-secondary ml-2">
                      </button>
                      <button
                              pButton
                              pRipple
                              *ngIf="canAddPermission"
                              class="p-button-success"
                              label="{{ 'Common.Button.Add' | translate }}"
                              icon="pi pi-plus"
                              (click)="openAddDialog()"
                          >
                      </button>
                  </div>
              </form>
          </p-accordionTab>
      </p-accordion>


      <div class="mt-2">
          <laas-data-table
              #AllocateConditionTable
              [(selectedRows)]="selectRow"
              [defaultColumns]="tableColumns"
              [value]="tableValue"
              [totalRecords]="this.pageInfo.totalRecords"
              dataKey="rowId"
              (tableOnPage)="this.tablePageChange($event)"
              (tableOnSort)="this.tableSort($event)"
              [loading]="isLoading"
              [lazy]="true"
              (setPageSize)="setPageSize($event)"
              [rows]="5"
              styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
          >

              <ng-template
                      pTemplate="body"
                      let-columns="columns"
                      let-rowData
              >

                  <td *ngFor="let col of columns">
                      <ng-container [ngSwitch]="col.field">

                          <ng-container *ngSwitchCase="'brand'" class="p-fluid">
                              <div class="overflow-text">
                                  {{ rowData[col.field] | optionsMapping: brandOptions | replaceNullWith: '-' }}
                              </div>
                          </ng-container>

                          <ng-container *ngSwitchDefault class="p-fluid">
                              <ng-container [ngSwitch]="col.dataType">
                                  <ng-container *ngSwitchCase="'date'">
                                      <div class="overflow-text">
                                          {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                      </div>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                      <div class="overflow-text">
                                          {{ rowData[col.field] | replaceNullWith:'-'}}
                                      </div>
                                  </ng-container>
                              </ng-container>
                          </ng-container>

                      </ng-container>
                  </td>
              </ng-template>


          </laas-data-table>

      </div>

    </p-card>
    <p-dialog header="{{ 'AllocationConstraint.AddForm.Header' | translate }}" [modal]="true" [(visible)]="showDialog" (onHide)="closeAddDialog()" [style]="{ width: '60vw', height: '70vh' }">
      <div class="p-fluid formgrid grid" [formGroup]="addForm">

          <!-- 貨主 -->
          <div class="field col-6">
            <label><span class="requiredStart">*</span>{{ 'AllocationConstraint.Search.storer' | translate }}</label>
            <p-dropdown  formControlName="storer" [options]="storerOption"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                        [showClear]="true" [virtualScroll]="false"
                        [ngClass]="{'p-invalid': addForm.get('storer')?.invalid && addFormSubmitted}">
            </p-dropdown>
          </div>

          <!-- 品牌 -->
          <div class="field col-6">
            <label><span class="requiredStart">*</span>{{ 'AllocationConstraint.Search.brand' | translate }}</label>
            <p-dropdown  formControlName="brand" [options]="brandOptions"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                        [showClear]="true" [filter]="true" filterBy="label" [virtualScroll]="false"
                        [ngClass]="{'p-invalid': addForm.get('brand')?.invalid && addFormSubmitted}">
            </p-dropdown>
          </div>

          <!-- 料號 -->
          <div class="field col-6">
            <label><span class="requiredStart">*</span>{{ 'AllocationConstraint.Search.sku' | translate }}</label>
            <input type="text" pInputText formControlName="sku" [ngClass]="{'p-invalid': addForm.get('sku')?.invalid && addFormSubmitted}"/>
          </div>

          <!-- 條件組合：checkType + checkCondition + checkValue1 -->
          <div class="field col-12">
              <label><span class="requiredStart">*</span>{{'AllocationConstraint.AddForm.CheckTypeSetting' | translate }}</label>
              <div class="formgrid grid">

              <!-- 比對類型 -->
              <div class="field col-4">
                  <p-dropdown  formControlName="checkType" [options]="addCheckTypeOption"
                              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true" [filter]="true" filterBy="label" [virtualScroll]="false"
                              [ngClass]="{'p-invalid': addForm.get('checkType')?.invalid && addFormSubmitted}">
                  </p-dropdown>
              </div>

              <!-- 條件符號 -->
              <div class="field col-2">
                  <p-dropdown formControlName="checkCondition"
                    [options]="getCurrentCheckConditionOptions(addForm.get('checkType')?.value)"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                  </p-dropdown>
              </div>

              <!-- 條件值 -->
              <div class="field col-6" *ngIf="addForm.get('checkType')?.value === 'DATE_CODE'">
                  <input pInputText formControlName="checkValue1" (blur)="onCheckValue1()" placeholder="EX:202401" />
                  <small class="p-error" *ngIf="checkValue1Invalid"> {{'AllocationConstraint.Message.CheckValue1Valid' | translate }}</small>
              </div>

              <div class="field col-6" *ngIf="addForm.get('checkType')?.value === 'VENDOR_LOT'">
                <input formControlName="checkValue1" type="text" pInputText placeholder="{{'Common.PlaceHolder.EnterInput' | translate }}"/>
                <small class="p-error" *ngIf="checkValue1Invalid">{{'AllocationConstraint.Message.CheckValue1Valid' | translate }}</small>
              </div>

              <!-- <div class="field col-6" *ngIf="addForm.get('checkType')?.value === 'VENDOR_LOT'">
                <p-chips formControlName="checkValue1" [separator]="' '" placeholder="{{'AllocationConstraint.AddForm.VendorLot.Placeholder' | translate }}"></p-chips>
                <small class="p-error" *ngIf="checkValue1Invalid">{{'AllocationConstraint.Message.CheckValue1Valid' | translate }}</small>
              </div> -->

              </div>
          </div>
          <label><span class="requiredStart">*</span>{{'AllocationConstraint.AddForm.DateRange' | translate }}</label>
          <div class="grid field col-12 mb-6">
              <div class="col-12 md:col-6 laas-calendar">
                <laas-calendar
                  #addFormStartDate
                  [title]="'AllocationConstraint.AddForm.StartDate'"
                  [enableMaxDateIsToday]="false"
                  [showCustomTime]="false"
                  [selectionMode] ="'single'"
                  (onDateChange)="dateOnChange($event, 0)">
                </laas-calendar>
              </div>

              <div class="col-12 md:col-6 laas-calendar">
                <laas-calendar
                  #addFormEndDate
                  [title]="'AllocationConstraint.AddForm.EndDate'"
                  [enableMaxDateIsToday]="false"
                  [showCustomTime]="false"
                  [selectionMode] ="'single'"
                  (onDateChange)="dateOnChange($event, 1)">
                </laas-calendar>
              </div>
            </div>
        <div class="flex justify-end gap-2">
          <p-button label="Cancel" severity="secondary" (click)="closeAddDialog()" />
          <p-button label="Save" (click)="saveConstraint()" />
        </div>
      </div>
    </p-dialog>
<help-dock
  [permissionCode]="viewPermission"
  [lang]="currentLang">
</help-dock>
